export const JFROG_TENANT_ID = "b20fcaa2-e34e-4822-811b-fb9adf5dabc5";

// The executive dashboard completed its JFrog pilot and is now the default
// experience for every tenant. Keep this function as the single rollout seam
// so future staged dashboard changes do not get scattered across components.
export const isExecutiveDashboardEnabled = () => true;

export const isCurrencyRiskEnabled = (tenantId) => tenantId === JFROG_TENANT_ID;
